import {
    PortfolioSummaryChartBarsData,
    PortfolioSummaryChartGroupDataSell,
    PortfolioSummaryChartGroupData,
} from './portfolioSummaryChartBarData';
import { stackData, getMax, getMin, Series } from 'utils/stackedSeries';
import { PortfolioSummarySideNetOptions } from '../../store/instances/configuration/PortfolioSummaryConfigurationState';

export interface PortfolioSummaryChartSeriesData {
    groupNames: string[];
    maxX: number;
    minX: number;
    buy: Series<PortfolioSummaryChartGroupData, string>[];
    sell: Series<PortfolioSummaryChartGroupDataSell, string>[];
    net: Series<PortfolioSummaryChartGroupData, string>[];
    buyTotal: Series<PortfolioSummaryChartGroupData, string>[];
    sellTotal: Series<PortfolioSummaryChartGroupData, string>[];
    netTotal: Series<PortfolioSummaryChartGroupData, string>[];
}

export function getPortfolioSummaryChartSeriesData(
    chartData: PortfolioSummaryChartBarsData,
    sideNet: PortfolioSummarySideNetOptions
): PortfolioSummaryChartSeriesData {
    const stackedBuySeries = stackData(
        chartData.buy,
        'tradedValueLoc',
        'remainingValueLoc'
    );

    const stackedSellSeries = stackData(
        chartData.sell,
        'tradedValueLoc',
        'remainingValueLoc',
        'shortTradedValueLoc',
        'shortRemainingValueLoc'
    );

    const stackedNetSeries = stackData(
        chartData.net,
        'tradedValueLoc',
        'remainingValueLoc',
        'orderedValueLoc'
    );

    const stackedBuyTotalSeries = stackData(chartData.buy, 'totalValueLoc');
    const stackedSellTotalSeries = stackData(
        chartData.sell,
        'totalValueLoc',
        'shortTotalValueLoc'
    );
    const stackedNetTotalSeries = stackedNetSeries;

    return {
        groupNames: chartData.groupNames,
        buy: stackedBuySeries,
        sell: stackedSellSeries,
        net: stackedNetSeries,
        buyTotal: stackedBuyTotalSeries,
        sellTotal: stackedSellTotalSeries,
        netTotal: stackedNetTotalSeries,
        maxX:
            sideNet === 'side'
                ? getMax(stackedBuySeries, stackedSellSeries)
                : getMax(stackedNetSeries),
        minX: sideNet === 'side' ? 0 : getMin(stackedNetSeries),
    };
}
